import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../components/button'
import { Link } from "react-router-dom";
import { getPlans } from '../../../slices/plans'


const PaymentButtons = () => {

    const plans = useSelector((state) => state.plans.results)
    const user = useSelector((state) => state.auth.user)
    const dispatch = useDispatch()
    const [paymentbuttoncode, setPaymentbuttoncode] = useState("")

    const buttonTextRef = useRef("")
    const customAmountRef = useRef("")
    const redirectUrlRef = useRef("")
    const selectRef = useRef("")
    const copyButtonRef = useRef()

    useEffect(() => {
        return () => {
            dispatch(getPlans())
        }
    }, [])


    const copyToClipboard = str => {
        const el = document.createElement('textarea');  // Create a <textarea> element
        el.value = str;                                 // Set its value to the string that you want copied
        el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        el.style.position = 'absolute';
        el.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
        const selected =
            document.getSelection().rangeCount > 0        // Check if there is any content selected previously
                ? document.getSelection().getRangeAt(0)     // Store selection if found
                : false;                                    // Mark as false to know no selection existed before
        el.select();                                    // Select the <textarea> content
        document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
            document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
            document.getSelection().addRange(selected);   // Restore the original selection
        }
        copyButtonRef.current.innerHTML = gettext("Copied");
    };

    const generateConfig = (data) => {
        return btoa(JSON.stringify(data))
    }

    const safetext = (text) => {
        var table = {
            '<': 'lt',
            '>': 'gt',
            '"': 'quot',
            '\'': 'apos',
            '&': 'amp',
            '\r': '#10',
            '\n': '#13'
        };

        return text.toString().replace(/[<>"'\r\n&]/g, function (chr) {
            return '&' + table[chr] + ';';
        });
    };

    const handleChange = () => {
        const buttonText = safetext(buttonTextRef.current.value || '')
        const customAmount = customAmountRef.current.value || ''
        const redirectUrl = redirectUrlRef.current.value || ''
        const plan = selectRef.current.value || ''
        generateButton(plan, buttonText, customAmount, redirectUrl)
    }

    const generateButton = (id, text, customAmount, redirectUrl) => {
        let _paymentbuttoncode = ''
        let amount = ''
        let redirectUrlHtml = ''

        if (id !== '') {
            var data = {
                account: user.account,
                plan: parseInt(id),
                branding: true,
            }

            if (text === '') {
                text = plans.find(f => parseInt(id) == f.id).name
            }

            if (customAmount !== '') {
                amount = ` data-amount="${customAmount}"`
            }

            if (redirectUrl !== '') {
                redirectUrlHtml = ` data-redirect-url="${redirectUrl}"`
            }

            _paymentbuttoncode = `&lt;script src="https://askell.overcastcdn.com/js/dist/paymentbutton.js?v=2"&gt;&lt;/script&gt;<br/>
    &lt;button type="button" class="askell-payment-button" data-key="${generateConfig(data)}"${amount}${redirectUrlHtml}&gt;${text}&lt;/button&gt;`
        } else {
            _paymentbuttoncode = ''
        }

        setPaymentbuttoncode(_paymentbuttoncode)
    }

    const preview = () => {
        var new_page = window.open();
        new_page.document.write(`<iframe srcDoc='${htmlDecode(paymentbuttoncode)}' style='width: 100vw; height: 100vh; border: none'></iframe>`)
    }

    function htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header">
                        <h1 className="title">{gettext('Payment Buttons')}</h1>
                    </div>
                </div>
            </div>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4">
                            <p>{gettext('Payment buttons are simple JavaScript widgets linked to a subscription plan, allowing you to embed a subscription form on you website.')}</p>
                            <p>{gettext('Select a subscription plan, override the button text if you want, and copy the generated HTML code to your website.')}</p>
                        </div>
                        <div className="col-lg-6 col-12 mb-4">
                            <label>{gettext('Subscription plan')}</label>
                            <select ref={selectRef} className="form-select" onChange={() => handleChange()}>
                                <option value="">{gettext('Select a plan')}</option>
                                {plans.map((plan) =>
                                    <option key={plan.id} value={plan.id}>{plan.name}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-lg-6 col-12 mb-4">
                            <label>{gettext('Button text (leave empty for plan name)')}</label>
                            <input type="text" ref={buttonTextRef} onChange={() => handleChange()} className="form-control" />
                        </div>
                        <div className="col-lg-6 col-12 mb-4">
                            <label>{gettext('Custom amount (leave empty for plan amount)')}</label>
                            <input type="number" ref={customAmountRef} onChange={() => handleChange()} className="form-control" />
                        </div>
                        <div className="col-lg-6 col-12 mb-4">
                            <label>{gettext('Redirect URL after successful purchase (optional)')}</label>
                            <input type="url" ref={redirectUrlRef} onChange={() => handleChange()} className="form-control" />
                        </div>
                        {paymentbuttoncode !== '' &&
                            <div className="col-12 mb-4">
                                <label>{gettext('Generated HTML code')}</label>
                                <div className="copy-script text-break" dangerouslySetInnerHTML={{ __html: paymentbuttoncode }}></div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {paymentbuttoncode !== '' &&
                <div className="clamped text-end mb-5">
                    <button onClick={() => preview(htmlDecode(paymentbuttoncode))} className="btn btn-secondary mt-4 me-3">{gettext('Preview')}</button>
                    <button ref={copyButtonRef} className="btn btn-secondary mt-4" onClick={() => copyToClipboard(htmlDecode(paymentbuttoncode))}>{gettext('Copy script')}</button>
                </div>
            }
        </>
    )
}

export default PaymentButtons